import { RichTextSymbol, RichTextTool, RichTextToolDefinition } from './rich-text-tool.type';

export const DEFAULT_RICH_TEXT_TOOLS: RichTextTool[] = [
	'bold',
	'italic',
	'underline',
	'strikethrough',
	'separator',
	'alignLeft',
	'alignCenter',
	'alignRight',
	'alignJustify',
	'separator',
	'bulletList',
	'numberList',
	'link'
];

/**
 * For HTML that another application renders: everything except alignment, which this suite stores as
 * `nha-align-*` classes that only its own stylesheet defines.
 */
export const DOCUMENT_RICH_TEXT_TOOLS: RichTextTool[] = [
	'bold',
	'italic',
	'underline',
	'strikethrough',
	'separator',
	'heading',
	'bulletList',
	'numberList',
	'link',
	'symbol',
	'clearFormatting'
];

/** Characters common in parent-facing copy but hard to type. Inserted as plain text, so they match the surrounding font. */
export const RICH_TEXT_SYMBOLS: readonly RichTextSymbol[] = [
	{ char: '→', name: 'Right arrow' },
	{ char: '←', name: 'Left arrow' },
	{ char: '↑', name: 'Up arrow' },
	{ char: '↓', name: 'Down arrow' },
	{ char: '•', name: 'Bullet' },
	{ char: '✓', name: 'Check mark' },
	{ char: '★', name: 'Star' },
	{ char: '…', name: 'Ellipsis' },
	{ char: '–', name: 'En dash' },
	{ char: '—', name: 'Em dash' },
	{ char: '©', name: 'Copyright' },
	{ char: '®', name: 'Registered' },
	{ char: '™', name: 'Trademark' },
	{ char: '°', name: 'Degree' },
	{ char: '½', name: 'One half' },
	{ char: 'ñ', name: 'n with tilde' },
	{ char: '¿', name: 'Inverted question mark' },
	{ char: '¡', name: 'Inverted exclamation mark' }
];

export const RICH_TEXT_TOOL_DEFINITIONS: Record<Exclude<RichTextTool, 'separator'>, RichTextToolDefinition> = {
	bold: { id: 'bold', label: 'Bold', icon: 'format_bold', command: 'bold', toggle: true },
	italic: { id: 'italic', label: 'Italic', icon: 'format_italic', command: 'italic', toggle: true },
	underline: { id: 'underline', label: 'Underline', icon: 'format_underlined', command: 'underline', toggle: true },
	strikethrough: { id: 'strikethrough', label: 'Strikethrough', icon: 'strikethrough_s', command: 'strikeThrough', toggle: true },
	heading: { id: 'heading', label: 'Heading', icon: 'title', command: 'formatBlock', commandValue: 'h3', toggle: false },
	alignLeft: { id: 'alignLeft', label: 'Align left', icon: 'format_align_left', command: 'justifyLeft', toggle: true },
	alignCenter: { id: 'alignCenter', label: 'Align center', icon: 'format_align_center', command: 'justifyCenter', toggle: true },
	alignRight: { id: 'alignRight', label: 'Align right', icon: 'format_align_right', command: 'justifyRight', toggle: true },
	alignJustify: { id: 'alignJustify', label: 'Justify', icon: 'format_align_justify', command: 'justifyFull', toggle: true },
	bulletList: { id: 'bulletList', label: 'Bulleted list', icon: 'format_list_bulleted', command: 'insertUnorderedList', toggle: true },
	numberList: { id: 'numberList', label: 'Numbered list', icon: 'format_list_numbered', command: 'insertOrderedList', toggle: true },
	link: { id: 'link', label: 'Add link', icon: 'link', command: 'createLink', toggle: false },
	symbol: { id: 'symbol', label: 'Insert symbol', icon: 'emoji_symbols', command: 'insertText', toggle: false },
	clearFormatting: { id: 'clearFormatting', label: 'Clear formatting', icon: 'format_clear', command: 'removeFormat', toggle: false }
};
